module.exports = {
    "BLOG_URL": "https://www-stagetre.xpressdocs.com/s/blog/blog/?cat=317",
    "BUILD3_CONDITIONS": "[\"build_path\"]",
    "CC_NEW_FILE_CHECK": false,
    "DS_SERVER_URL": "https://ds-dev.xpressdocs.com",
    "DS_SERVER_URLS_WITH_VERSIONS": [
        {
            "host": "https://ds-dev01.xpressdocs.com",
            "version": "5.22.0"
        },
        {
            "host": "https://ds-dev02.xpressdocs.com",
            "version": "5.22.0"
        },
        {
            "host": "https://v7-ds-dev01.xpressdocs.com",
            "version": "7.1.2"
        },
        {
            "host": "https://v7-ds-dev02.xpressdocs.com",
            "version": "7.1.2"
        }
    ],
    "FB_APP_ID": 319825462259732,
    "FONT_SIZE_WARN": 8.5,
    "GOOGLE_CLIENT_ID": "333093340972-kgogplmpcekud9reu4mgj30nu11npu5b.apps.googleusercontent.com",
    "INCLUDE_SAMPLE_CARD_COST": true,
    "MAX_NUM_DAYS_OUT_FOR_SCHEDULING_ORDERS": 90,
    "MAX_NUM_DAYS_REORDER": 540,
    "MAX_NUM_MINUTES_CANCEL_ORDER": 10,
    "MAX_ORDER_PER_CART": 50,
    "MN_HOMEVALUE_URL": "https://proj-34013.awsdev.xpressdocs.com/app/home-value/",
    "MN_XPRESSLINKS_URL": "https://proj-34013.awsdev.xpressdocs.com/app/xpresslinks/",
    "TEMPLATES_SOLR_URL": "https://solrlab.awsdev.xpressdocs.com/solr/XDTemplates/",
    "UPLOAD_MAX_PHP_FILE_SIZE": 100000000,
    "USER_DEACTIVATED_BECOMES_DELETED_DAYS": 735
};

